// extracted by mini-css-extract-plugin
export default {"controlButton":"YvlilO","hidden":"mbYhf8","container":"Uq67sU","fillAllSpace":"IvmxMo","fullScreen":"NcNpGQ"};